__webpack_require__.p = "/shifts-in-both-supply-and-demand-curves/";